var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smd-note',{staticClass:"form-required-note"},[_c('text-string',{attrs:{"label-id":"txt133"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }